/* eslint-disable */
(function (window) {
    window.recaptchaData = window.recaptchaData || {};
    window.recaptchaData.recaptchaEventsHolder = window.recaptchaData.recaptchaEventsHolder || {};
    window.recaptchaData.recaptchaCallbacksArr = window.recaptchaData.recaptchaCallbacksArr || [];

    window.onRecaptchaLoad = function () {
        var recaptchaCallbacksArr = window.recaptchaData.recaptchaCallbacksArr;
        for (var i = 0; i < recaptchaCallbacksArr.length; i += 1) {
            if (typeof recaptchaCallbacksArr[i] === 'function') {
                recaptchaCallbacksArr[i]();
            }
        }
        window.recaptchaData.recaptchaCallbacksArr = [];
    };
}(window));
/* eslint-enable */

module.exports = {
    init: function () {
        if (!window.grecaptcha) {
            var url = window.SitePreferences.RECAPTCHA_API_URL;
            var script = document.createElement('script');

            script.type = 'text/javascript';
            script.async = true;
            script.src = url;
            document.getElementsByTagName('head')[0].appendChild(script);
        }
    },

    attach: function (form, callback) {
        var $holder = form.find('.js-recaptcha-input')[0];

        window.recaptchaData.recaptchaCallbacksArr.push(function () {
            var holderId = window.grecaptcha.render($holder, {
                sitekey: window.SitePreferences.RECAPTCHA_SITE_KEY,
                theme: 'light',
                size: 'invisible',
                badge: 'bottomright',
                isolated: true,
                callback: typeof callback === 'function' ? callback : null
            });
            window.recaptchaData.recaptchaEventsHolder[form.attr('name')] = holderId;
        });
    },

    showReCaptcha: function (formName) {
        if (window.grecaptcha && formName && formName in window.recaptchaData.recaptchaEventsHolder) {
            window.grecaptcha.execute(window.recaptchaData.recaptchaEventsHolder[formName]);
        }
    }

};
